import styled from 'styled-components';

export const SimuladoresContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5%;
`;

export const BannerContent = styled.img`
  width: 118%;
  max-width: 1235px;
  cursor: pointer;
  margin-bottom: 32px;
  margin-left: -10%;
`;

export const TabPagesContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  

  
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;

`;

interface IPropsButton {
  isActive: boolean;
}

export const ButtonTab = styled.button<IPropsButton>`
  all: unset;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  padding: 0.675rem 0.875rem;
  width: 100%;
  min-height: 72px;

  font-weight: ${(props) => (props.isActive ? 'bold' : 'normal')};
  font-size: 1rem;
  line-height: 1.45;

  color: ${(props) => (props.isActive ? '#EC6643' : '#3f3f46')};

  border-top: ${(props) =>
    props.isActive ? '4px solid #EC6643' : '1px solid #D4D6DB'};
  border-right: 1px solid #D4D6DB;
  border-left: 1px solid #D4D6DB;
  border-bottom: ${(props) => (props.isActive ? 'none' : '1px solid #D4D6DB')};

  border-radius: 8px 8px 0 0;
  background: ${(props) => (props.isActive ? '#fff' : '#FCFCFD')};

  cursor: pointer;
  white-space: normal;
  word-break: normal;

  @media (max-width: 480px) {
    font-size: 0.75rem;
    min-height: 56px;
    padding: 0.5rem;
  }
`;
